import { FC } from "react";
import { Grid, Tab, Icon, SemanticICONS } from "semantic-ui-react";
import { FeaturesTabProps } from "./types";

const MarketplaceAppDetailFeaturesTab: FC<FeaturesTabProps> = ({
  features,
}) => (
  <Tab.Pane className="marketplace-app-detail-features">
    <Grid className="features-tab-grid" relaxed="very">
      {features.map((feature, index) => (
        <Grid.Row key={index} className="feature-item margin-top-10">
          <Grid.Column width={16} className="feature-content">
            <h4 className="feature-title color-black">
              {" "}
              <Icon name={(feature.icon as SemanticICONS) || "star"} />{" "}
              {feature.title}
            </h4>
            <p className="feature-description padding-left-20">
              {feature.description}
            </p>
          </Grid.Column>
        </Grid.Row>
      ))}
    </Grid>
  </Tab.Pane>
);

export default MarketplaceAppDetailFeaturesTab;
